import EventsMap from "./plugins/EventsMap";
import ParseForm from "./plugins/ParseForm";

$('document').ready(function () {
	let eventsMap = new EventsMap();
	let parseForm = new ParseForm();
	initFormsValidation();
	initLabelClick();
	initMobileNav();
	initSlickCarousel();
	initSameHeight();
	initOpenClose();
	initTabs();
	initFancybox();
	initPopup();
	initShowOther();
	initSummaryDonate();
	initCustomHover();
	initWspActions();
});

function initWspActions() {
	$('body').on('click', '.wsp-container > h2', function () {
		$(this).next('ul').slideToggle();
	});
}

function initLabelClick() {
	$('a label').on('click', function() {
		$('#' + $(this).attr('for')).prop('checked', true);
	});
}

function initFormsValidation() {
	$("#ProcessForm").validate({
		submitHandler: function(form) {
			$("#ProcessForm").find('*[name="pstep_finish"]').css('pointer-events', 'none');
			form.submit();
		},
		rules: {
			billing_first_namename: {
				required: true,
			},
			billing_last_namename: {
				required: true,
			},
			donor_email_addressname: {
				required: true,
				email: true,
			},
			responsive_payment_typecc_numbername: {
				required: () => jQuery('[name="responsive_payment_typepay_typeradio"]:checked').val() === 'credit',
				creditcard: true,
			},
			responsive_payment_typecc_cvvname: {
				required: () => jQuery('[name="responsive_payment_typepay_typeradio"]:checked').val() === 'credit',
			},
			billing_addr_street1name: {
				required: true,
			},
			billing_addr_cityname: {
				required: true,
			},
			billing_addr_state: {
				required: true,
			},
			billing_addr_zipname: {
				required: true,
			},
			billing_addr_country: {
				required: true,
			},
			custom_control_auto_sizing: {
				required: false,
			},
			responsive_payment_typerouting_numbername: {
				required: () => jQuery('[name="responsive_payment_typepay_typeradio"]:checked').val() === 'ach',
			},
			responsive_payment_typebank_accountname: {
				required: () => jQuery('[name="responsive_payment_typepay_typeradio"]:checked').val() === 'ach',
			},
			responsive_payment_typeverify_bank_accountname: {
				required: () => jQuery('[name="responsive_payment_typepay_typeradio"]:checked').val() === 'ach',
			},
			responsive_payment_typeach_confirmname: {
				required: () => jQuery('[name="responsive_payment_typepay_typeradio"]:checked').val() === 'ach',
			},
		}
	});
	$("#RSVPForm").validate({
		rules: {
			cons_first_name: {
				required: true,
			},
			cons_last_name: {
				required: true,
			},
			cons_email: {
				required: true,
				email: true,
			},
		}
	});
}

// add classes on hover/touch
function initCustomHover() {
	jQuery('#menu-primary-navigation li, #menu-primary-navigation a').touchHover({});
}

function initSummaryDonate() {
	jQuery('[name="level_standardexpanded"]').on('change', function(){
		calculate(jQuery(this));
	});

	jQuery('.js-other-value input').on('input', function(){
		calculate(jQuery(this));
	});
}
function calculate(input){
	var val = parseInt(input.data('amount') ? input.data('amount').replace('$', '').replace(',', '') : 0) || parseInt(input.val());
	if(input.data('amount') && input.data('amount').toLowerCase() == 'other') {
		val = parseInt(input.closest('.tab-pane').find('.js-other-value input').val());
	}
	if(val) {
		jQuery('.js-total-value').text('$'+val);
	}
}

function initShowOther() {
	jQuery('.donate-form-large .input-row [type="radio"]').on('change', function(){
		var hiddenInput = jQuery(this).closest('.tab-pane').find('.js-other-value');
		if(jQuery(this).data('amount').replace(/(\r\n|\n|\r)/gm, "").toLowerCase() == 'other' && jQuery(this).is(':checked')) {
			hiddenInput.show();
		} else {
			hiddenInput.hide();
		}
	})
	jQuery('.donate-form-large .input-row [type="radio"]').trigger('change');
}

function initPopup() {
	var popup = jQuery('.popup-block'),
	opener = popup.find('.opener'),
	activeClass = 'open';

	opener.on('click', function(e){
		e.preventDefault();
		popup.toggleClass(activeClass);
	});

	jQuery(document).on('click', function(e) {
		if (!popup.is(e.target) && popup.has(e.target).length === 0) {
			popup.removeClass(activeClass)
		}
	});
}

// content tabs init
function initTabs() {
	jQuery('.nav-tabs').tabset({
		tabLinks: 'a',
		defaultTab: true,
		onInit: function() {
			var actValue = jQuery('.donate-form-large .tab-pane.active').find('.input-row [type="radio"]:checked');
			calculate(actValue);
		},
		onChange: function() {
			var actValue = jQuery('.donate-form-large .tab-pane.active').find('.input-row [type="radio"]:checked');
			calculate(actValue);
		}
	});

	jQuery('.js-tabs').tabset({
		tabLinks: 'a',
		defaultTab: true,
	});
}

// open-close init
function initOpenClose() {
	jQuery('.open-close-team').openClose({
		activeClass: 'active--team',
		opener: '.opener-team',
		slider: '.slide-team',
		animSpeed: 400,
		hideOnClickOutside: true,
		effect: 'fade'
	});
	$('body').on('click', '.team-section .open-close-team > .opener-team', function() {
		if ($(this).parent().hasClass('active--team')) {
			$('body, html').animate({scrollTop: $(this).parent().find('.slide-team').offset().top - 150}, 300);
		}
	});
}

// align blocks height
function initSameHeight() {
	jQuery('.slide-show').sameHeight({
		elements: '.slick-slide',
		flexible: true,
		biggestHeight: true
	});

	jQuery('.team-section').sameHeight({
		elements: '.text',
		biggestHeight: true,
		multiLine: true
	});
	jQuery('.ebooks-container').sameHeight({
		elements: '.text',
		biggestHeight: true,
		multiLine: true
	});
}

// slick init
function initSlickCarousel() {
	jQuery('.slide-show').slick({
		slidesToScroll: 1,
		rows: 0,
		arrows: false,
		dots: true,
		autoplay: true,
		dotsClass: 'slick-dots',
		fade: true
	});
	if (jQuery('.video-slider .slider > div').length > 2) {
		jQuery('.video-slider .slider').slick({
			slidesToScroll: 1,
			mobileFirst: true,
			centerMode: true,
			centerPadding: 0,
			infinity: true,
			rows: 0,
			arrows: false,
			dots: true,
			dotsClass: 'slick-dots',
			fade: false,
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			},
			]
		});
	}
}

// mobile menu init
function initMobileNav() {
	jQuery('#menu-primary-navigation .menu-item-has-children > ul')
	.wrap($('<div/>', {class: 'drop'}))
	.parent('.drop').prepend('<a href="#" class="nav-opener"><span class="burger"><span></span></span></a>');
	jQuery('body').mobileNav({
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener',
		hideOnClickOutside: true,
		menuDrop: '#nav'
	});
}


// lightbox init
function initFancybox() {
	jQuery('a.btn-lightbox, [data-fancybox]').fancybox({
		parentEl: 'body',
		margin: [50, 0],
		loop: false,
		infobar: false,
		baseClass: 'search-lightbox'
	});
	jQuery('a.btn-v-lightbox, [data-fancybox]').fancybox({
		parentEl: 'body',
		margin: [50, 0],
		loop: false,
		infobar: false,
		baseClass: 'v-lightbox'
	});
}
